import React from 'react';
import Checkbox from '@material-ui/core/Checkbox';
import clsx from 'clsx';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { makeStyles } from '@material-ui/styles';

const styles = makeStyles((theme) => ({
  root: {
    '&:hover': {
      backgroundColor: 'transparent',
    },
  },
  icon: {
    width: 16,
    height: 17,
    borderRadius: 4,
    border: 'solid 1px var(--grass)',
    'input:hover ~ &': {
      backgroundColor: '#ebf1f5',
    },
  },
  checkedIcon: {
    backgroundColor: 'var(--grass)',
    backgroundImage: 'linear-gradient(180deg,hsla(0,0%,100%,.1),hsla(0,0%,100%,0))',
    '&:before': {
      display: 'block',
      width: 16,
      height: 16,
      backgroundImage:
        "url(\"data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16'%3E%3Cpath" +
        " fill-rule='evenodd' clip-rule='evenodd' d='M12 5c-.28 0-.53.11-.71.29L7 9.59l-2.29-2.3a1.003 " +
        "1.003 0 00-1.42 1.42l3 3c.18.18.43.29.71.29s.53-.11.71-.29l5-5A1.003 1.003 0 0012 5z' fill='%23fff'/%3E%3C/svg%3E\")",
      content: '""',
    },
    'input:hover ~ &': {
      backgroundColor: 'var(--grass)',
    },
  },
}));

export default function FormCheckbox({ id, checked, handleChange, label }) {
  return (
    <FormControlLabel
      control={
        <Checkbox
          id={id || 'checkbox'}
          checked={checked}
          onChange={(e) => handleChange(e.target.checked)}
        />
      }
      label={label}
    />
  );
}

export const CustomCheckbox = ({ id, checked, handleChange, label }) => {
  const classes = styles();

  return (
    <Checkbox
      id={id}
      checked={checked}
      onChange={(e) => handleChange(e)}
      checkedIcon={<span className={clsx(classes.icon, classes.checkedIcon)} />}
      icon={<span className={classes.icon} />}
    >
      {label}
    </Checkbox>
  );
};
